import React from 'react';
import Layout from '../src/components/Layout/Layout';

function App() {
  return (
    <div className="App">
        <Layout/>
    </div>
  );
}

export default App;
